/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_NodInputs */

const fr_fancy_vast_otter_nod = /** @type {(inputs: Fancy_Vast_Otter_NodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`année`)
};

/**

* @param {Fancy_Vast_Otter_NodInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_nod = /** @type {((inputs?: Fancy_Vast_Otter_NodInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_NodInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_nod(inputs)
});